import React from "react";
import { Alert } from "react-bootstrap";
import { FormikErrors } from "formik";
import { FormValues } from "./types";

function errorMessages(errors: unknown): string[] {
  if (typeof errors === "string") return [errors];
  if (!errors || typeof errors !== "object") return [];
  return Object.values(errors).reduce<string[]>(
    (messages, value) => messages.concat(errorMessages(value)),
    []
  );
}

export const FormValidationErrors = ({
  errors,
  submitCount,
  isValidating,
}: {
  errors: FormikErrors<FormValues>;
  submitCount: number;
  isValidating: boolean;
}) => {
  const messages = errorMessages(errors);
  if (!submitCount || isValidating || !messages.length) return null;

  return (
    <Alert variant="danger" className="simulacao-error">
      Revise os campos abaixo para simular:
      <ul>
        {messages.map((message, index) => (
          <li key={index}>{message}</li>
        ))}
      </ul>
    </Alert>
  );
};
